import { NavLink } from 'react-router-dom';
import {
  IconChangeLoClock,
  IconChat,
  IconCopyTwo,
  IconDown,
  IconUser,
} from '@ui/src';
import { NewApplicationStatus } from '../../types';
import { NewApplicationInfoBottomTypes } from '../types';

import cn from '../styles.module.css';

const NewApplicationInfoBottom = ({
  setResponsiblePopupVisible,
  canSelectResponsible,
  newApplicationInfo,
  setUserSidepanelVisible,
  applicationId,
  applicationChat,
  setChangeLogsPanelIsOpen,
  onIDCopy,
  idCopySuccess,
}: NewApplicationInfoBottomTypes) => (
  <div className={cn.newApplicationInfoBottom}>
    <div className={cn.newApplicationInfoBottomLeft}>
      <button
        type="button"
        className={cn.newApplicationAssignResponsibleButton}
        onClick={() => setResponsiblePopupVisible(true)}
        disabled={
          !canSelectResponsible ||
          newApplicationInfo?.status === NewApplicationStatus.ACCEPTED ||
          newApplicationInfo?.status === NewApplicationStatus.DECLINED
        }
      >
        {newApplicationInfo?.reviewEmployee
          ? `${newApplicationInfo?.reviewEmployee?.profile?.firstName} ${newApplicationInfo?.reviewEmployee?.profile?.lastName}`
          : 'Select Responsible'}
        <IconDown className={cn.marginLeft} />
      </button>
      <div className={cn.newApplicationInfoBottomSeparator} />
      <button
        type="button"
        className={`${cn.newApplicationAssignResponsibleButton} ${cn.withPadding}`}
        onClick={() => setUserSidepanelVisible(true)}
      >
        <IconUser className={cn.marginRight} width={16} height={16} />
        View user
      </button>
      {applicationId && applicationChat && (
        <NavLink
          to={`/messages/requests${
            applicationChat.employee ? '/in-progress' : '/completed'
          }/${applicationChat.id}`}
          className={`${cn.newApplicationAssignResponsibleButton} ${cn.link}`}
          target="_blank"
        >
          <IconChat className={cn.marginRight} width={16} height={16} />
          <span>Application chat</span>
        </NavLink>
      )}
      <button
        type="button"
        className={`${cn.newApplicationAssignResponsibleButton} ${cn.withPadding}`}
        onClick={() => setChangeLogsPanelIsOpen(true)}
      >
        <IconChangeLoClock className={cn.marginRight} width={17} height={17} />
        Logs
      </button>
    </div>
    {applicationId && (
      <div className={cn.newApplicationId}>
        <div className={cn.newApplicationIdContent}>
          {`ID: ${applicationId}`}
        </div>
        <button
          type="button"
          className={cn.copyButton}
          aria-label="Copy application ID"
          onClick={() => onIDCopy(applicationId)}
        >
          <IconCopyTwo width={16} height={16} />
          <div
            className={`${cn.copySuccess} ${idCopySuccess ? cn.visible : ''}`}
          >
            Copied!
          </div>
        </button>
      </div>
    )}
  </div>
);

export default NewApplicationInfoBottom;
